import _ from 'lodash'
import * as React from 'react'
import { IconButton, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import CancelIcon from '@mui/icons-material/Cancel'

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'var( --color-green)',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const TextTitle = styled('div')(() => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontWeight: 700,
  paddingLeft: '0.375em',
  fontSize: '0.875em',
  lineHeight: '1.25em',
  textAlign: 'center',
  color: '#fff',
}))

const DrawerHeader = ({ onClick, scientificName, commonName, classifier }) => {
  const wordsLength = `${scientificName + classifier}`.length > 34
  const drawerHeight = wordsLength ? '4em' : '3.4em'

  return (
    <Header
      style={{
        minHeight: drawerHeight,
        paddingRight: '4px',
      }}>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box sx={{ width: '100%', alignSelf: commonName ? 'end' : 'center' }}>
          <TextTitle>
            {Boolean(commonName) && (
              <>
                <span>{_.toUpper(commonName)}</span>
                <br />
              </>
            )}
            <span style={{ fontStyle: 'italic', fontWeight: 600 }}>{scientificName}</span>
            {wordsLength ? <br /> : null}
            <span style={{ fontSize: 12 }}>
              {Boolean(classifier) ? ` ${classifier}` : ''}
            </span>
          </TextTitle>
        </Box>
        <Box width="13%">
          <IconButton onClick={onClick} sx={{ height: '40px' }}>
            <CancelIcon sx={{ width: 20, height: 20, fill: '#a8f446' }} />
          </IconButton>
        </Box>
      </Box>
    </Header>
  )
}
export default DrawerHeader
